import React from "react";
import { NavLink } from "react-router-dom";

import style from "./NavItem.module.scss";

const NavItem = ({
  to,
  Icon,
  title,
  strokeWidth = "1px",
  width = "24px",
  height = "24px",
}) => {
  return (
    <span className={style.navItem}>
      <NavLink
        to={to}
        className={({ isActive }) =>
          isActive ? `${style.link} ${style.active}` : style.link
        }
      >
        <Icon
          strokeWidth={strokeWidth}
          width={width}
          height={height}
          className={style.icon}
        />
        <span className={style.label}>{title}</span>
      </NavLink>
    </span>
  );
};

export default NavItem;
